import { Field, SingleSelectDropdown } from "@carbon6/c6-frontend-design";
import type { ConfigRecordingMode } from "@/api";
import { hatcheryDropdownModes } from "@/app/theme";
import { formatRecordingMode } from "@/components/filter/datasetFilters";
import type { DraftConfiguration } from "./datasetConfigurationDraft";
import { formatDraftRecordingMode } from "./reviewDiffModel";

/** 자동 복귀와 수동 지정을 한 입력에서 편집한다. 실제 자동 판정은 저장 시 서버가 한다. */
export function RecordingModeCard({
  draft,
  locked,
  onChange,
}: {
  draft: DraftConfiguration;
  locked: boolean;
  onChange: (mode: ConfigRecordingMode) => void;
}) {
  const mode = draft.recordingMode;
  const options = [
    {
      value: "auto",
      label: mode.modified_manually ? "자동 판정" : formatDraftRecordingMode(draft),
    },
    { value: "teleoperation", label: `${formatRecordingMode("teleoperation")} (수동 지정)` },
    { value: "direct_teaching", label: `${formatRecordingMode("direct_teaching")} (수동 지정)` },
    { value: "none", label: "해당 없음 (수동 지정)" },
  ];
  return (
    <Field label="수집 방식" layout="inline" labelWidth="5rem" disabled={locked}>
      <SingleSelectDropdown
        mode={hatcheryDropdownModes.default}
        label="수집 방식"
        options={options}
        value={mode.modified_manually ? (mode.value ?? "none") : "auto"}
        disabled={locked}
        onValueChange={(value) => {
          if (value === "auto") {
            onChange({ modified_manually: false, value: null });
          } else if (value === "none" || value === "teleoperation" || value === "direct_teaching") {
            onChange({ modified_manually: true, value: value === "none" ? null : value });
          }
        }}
      />
    </Field>
  );
}
